export const ORG_DELETION_STATUSES = ['SCHEDULED', 'IN_PROGRESS', 'COMPLETED', 'CANCELLED', 'FAILED'] as const;

export type OrgDeletionStatus = typeof ORG_DELETION_STATUSES[number];

/** At most one row per org may be in one of these statuses (enforced by a partial unique index). */
export const OPEN_ORG_DELETION_STATUSES: readonly OrgDeletionStatus[] = ['SCHEDULED', 'IN_PROGRESS'];
